/* ─────────────────────────────────────────────
   KAYO Moto Switzerland – theme.js CLEAN
   JS globale leggero + compatibile con section custom
───────────────────────────────────────────── */

(function () {
  'use strict';

  /* Evita doppia inizializzazione in Shopify Theme Editor */
  if (window.KAYO_THEME_JS_CLEAN_LOADED) return;
  window.KAYO_THEME_JS_CLEAN_LOADED = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ─────────────────────────────
     Reveal on scroll
  ───────────────────────────── */
  function initReveal() {
    const revealEls = document.querySelectorAll('.rv:not(.vi)');

    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      revealEls.forEach((el) => el.classList.add('vi'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('vi');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -30px 0px'
    });

    revealEls.forEach((el) => observer.observe(el));
  }

  /* ─────────────────────────────
     Header: blur on scroll
     Non gestisce più hamburger globale.
     Il nuovo header usa data-kayo-mobile-toggle.
  ───────────────────────────── */
  function initHeaderScroll() {
    const header = document.querySelector('.site-header');

    if (!header) return;

    let ticking = false;

    function updateHeader() {
      const y = window.scrollY || 0;

      if (y > 80) {
        header.style.background = 'rgba(6,8,12,.92)';
        header.style.backdropFilter = 'blur(28px)';
        header.style.webkitBackdropFilter = 'blur(28px)';
      } else {
        header.style.background = 'rgba(6,8,12,.62)';
        header.style.backdropFilter = 'blur(20px)';
        header.style.webkitBackdropFilter = 'blur(20px)';
      }

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (ticking) return;

      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }, { passive: true });

    updateHeader();
  }

  /* ─────────────────────────────
     Tilt leggero solo desktop
     Non applicarlo su mobile/touch.
  ───────────────────────────── */
  function initTiltCards() {
    if (!isFinePointer || prefersReducedMotion) return;

    const cards = document.querySelectorAll('[data-tilt]');

    cards.forEach((card) => {
      let frame = null;

      function resetCard() {
        card.style.transition = 'transform .45s cubic-bezier(.16,1,.3,1)';
        card.style.transform = '';

        window.setTimeout(() => {
          card.style.transition = '';
        }, 450);
      }

      card.addEventListener('mousemove', (event) => {
        if (frame) cancelAnimationFrame(frame);

        frame = requestAnimationFrame(() => {
          const rect = card.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - 0.5;
          const y = (event.clientY - rect.top) / rect.height - 0.5;

          card.style.transition = 'none';
          card.style.transform = `perspective(1000px) rotateX(${-y * 5}deg) rotateY(${x * 5}deg) translateY(-3px)`;
        });
      });

      card.addEventListener('mouseleave', resetCard);
    });
  }

  /* ─────────────────────────────
     Product page thumbnail gallery
  ───────────────────────────── */
  function initProductGallery() {
    const mainImg = document.getElementById('main-img');
    const thumbs = document.querySelectorAll('#thumbs button');

    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((button) => {
      button.addEventListener('click', () => {
        thumbs.forEach((btn) => {
          btn.style.borderColor = 'rgba(255,255,255,.12)';
        });

        button.style.borderColor = 'var(--ca)';

        const thumbImg = button.querySelector('img');
        if (!thumbImg) return;

        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity .2s ease';

        window.setTimeout(() => {
          const largeSrc = thumbImg.src
            .replace('width=200', 'width=1600')
            .replace('&width=200', '&width=1600');

          mainImg.src = largeSrc;
          mainImg.style.opacity = '1';
        }, 150);
      });
    });
  }

  /* ─────────────────────────────
     Cart AJAX
     Aggiorna badge carrello senza reload.
  ───────────────────────────── */
  function initAjaxCart() {
    const forms = document.querySelectorAll('form[action="/cart/add"]');

    forms.forEach((form) => {
      if (form.dataset.kayoAjaxCartReady === 'true') return;
      form.dataset.kayoAjaxCartReady = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const originalText = button ? button.textContent : '';

        if (button) {
          button.disabled = true;
          button.textContent = 'Aggiunto ✓';
        }

        try {
          const formData = new FormData(form);

          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!addResponse.ok) {
            throw new Error('Errore aggiunta al carrello');
          }

          const cartResponse = await fetch('/cart.js', {
            headers: {
              'Accept': 'application/json'
            }
          });

          const cart = await cartResponse.json();

          updateCartBadges(cart.item_count);
        } catch (error) {
          console.warn('KAYO cart update failed:', error);

          if (button) {
            button.textContent = 'Errore';
          }
        } finally {
          if (button) {
            window.setTimeout(() => {
              button.disabled = false;
              button.textContent = originalText;
            }, 1600);
          }
        }
      });
    });
  }

  function updateCartBadges(count) {
    const cartLinks = document.querySelectorAll('[aria-label*="Carrello"]');

    cartLinks.forEach((cartLink) => {
      let badge = cartLink.querySelector('.cart-badge, .kayo-cart-badge');

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-badge';
        badge.style.cssText = [
          'position:absolute',
          'top:-4px',
          'right:-4px',
          'width:18px',
          'height:18px',
          'border-radius:50%',
          'background:var(--cp)',
          'font-size:9px',
          'display:grid',
          'place-items:center',
          'font-weight:700',
          'line-height:1'
        ].join(';');

        cartLink.style.position = 'relative';
        cartLink.appendChild(badge);
      }

      badge.textContent = count;
      badge.style.display = count > 0 ? 'grid' : 'none';
    });
  }

  /* ─────────────────────────────
     Collection drawer filters
     Compatibile con collection principale.
  ───────────────────────────── */
  function initCollectionDrawer() {
    const toggleBtn = document.getElementById('mc-filter-toggle');
    const overlay = document.getElementById('mc-overlay');
    const drawer = document.getElementById('mc-drawer');
    const closeBtn = document.getElementById('mc-drawer-close');
    const applyBtn = document.getElementById('mc-drawer-apply');
    const drawerBody = document.getElementById('mc-drawer-body');
    const sidebar = document.getElementById('mc-sidebar');

    if (!toggleBtn || !drawer || !overlay || !drawerBody || !sidebar) return;

    function initGroupToggle(button) {
      if (button.dataset.kayoFilterToggleReady === 'true') return;
      button.dataset.kayoFilterToggleReady = 'true';

      button.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));

        const body = this.nextElementSibling;

        if (body) {
          body.classList.toggle('collapsed', expanded);
        }
      });
    }

    function openDrawer() {
      if (drawerBody.children.length === 0) {
        drawerBody.innerHTML = sidebar.innerHTML;
        drawerBody.querySelectorAll('.mc-group-toggle').forEach(initGroupToggle);
      }

      drawer.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      toggleBtn.setAttribute('aria-expanded', 'false');
    }

    toggleBtn.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', closeDrawer);

    let startX = 0;

    drawer.addEventListener('touchstart', (event) => {
      if (!event.touches || !event.touches.length) return;
      startX = event.touches[0].clientX;
    }, { passive: true });

    drawer.addEventListener('touchend', (event) => {
      if (!event.changedTouches || !event.changedTouches.length) return;

      if (event.changedTouches[0].clientX - startX < -60) {
        closeDrawer();
      }
    }, { passive: true });

    document.querySelectorAll('.mc-group-toggle').forEach(initGroupToggle);
  }

  /* ─────────────────────────────
     Shopify Theme Editor support
  ───────────────────────────── */
  function initAll() {
    initReveal();
    initHeaderScroll();
    initTiltCards();
    initProductGallery();
    initAjaxCart();
    initCollectionDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();